<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16UZ9wk/images/frontcover.jpg?1703001166844" alt="This image is the cover for the book Fighters Over the Fleet"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fighters Over the Fleet
      </h1>
      <p class="bookDescription body article font2">
        <b>A tactical and technical history of the development of British, American, and Japanese naval air defense from the 1920s to the 1980s.</b><br/><br/> This is an account of the evolution of naval fighters for fleet air defense and the parallel evolution of the ships operating and controlling them, concentrating on the three main exponents of carrier warfare: the British Royal Navy, the U.S. Navy, and the Imperial Japanese Navy. It describes the earliest efforts from the 1920s, but it was not until radar allowed the direction of fighters that organized air defense became possible. Thus, major naval-air battles of the Second World War like Midway, the Pedestal convoy, the Philippine Sea, and Okinawa are portrayed as tests of the new technology. This was ultimately found wanting by the Kamikaze campaigns, leading to postwar moves towards computer control and new kinds of fighters.<br/><br/> After 1945 the threats of nuclear weapons and standoff missiles compounded the difficulties of naval air defense. The second half of the book covers R.N. and U.S.N. attempts to solve these problems, looking at the American experience in Vietnam and British operations in the Falklands War. It concludes with the ultimate U.S. development of techniques and technology to fight the Outer Air Battle in the 1980s, which in turn point to the current state of carrier fighters and the supporting technology.<br/><br/> Based largely on documentary sources, some previously unused, this book will appeal to both the naval and aviation communities.<br/><br/><b>“<i>Fighters Over the Fleet</i> provides more information about fleet air defense than any other work currently available. It is recommended for specialist as well aviation-minded readers.” —Naval Historical Foundation</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Norman Friedman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Seaforth Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6d44d03a